export default __webpack_public_path__ + "static/media/download_andere methodieken.4533f7d0.pdf";